/*--------------------------------------------------------------------
   HEY NOW RECORDS — Custom JS
   All custom behavior added on top of the Horizon theme lives here.
   If something breaks, the bug is almost certainly in this file.
--------------------------------------------------------------------*/

/*-------- HEADER SCROLL STATE --------
   Toggles [data-scrolled] on <header-component> based on scroll
   position. custom.css uses this to switch the header from
   transparent (at the top) to translucent dark + blur. */
const initHeaderScroll = () => {
  const header = document.querySelector('header-component');
  if (!header) return;

  const SCROLL_THRESHOLD = 8;
  let raf = null;

  const update = () => {
    raf = null;
    if (window.scrollY > SCROLL_THRESHOLD) {
      header.setAttribute('data-scrolled', '');
    } else {
      header.removeAttribute('data-scrolled');
    }
  };

  const onScroll = () => {
    if (raf !== null) return;
    raf = requestAnimationFrame(update);
  };

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderScroll);
} else {
  initHeaderScroll();
}
